import {addBundleToCart, toggleSpinner, updateCartWithBundle} from "../global/utilities";

const firstPurchase = document.querySelector('.first-purchase');

if(firstPurchase) {
    const stepDots = firstPurchase.querySelectorAll('button[data-step]');
    const steps = firstPurchase.querySelectorAll('div[data-step]');
    const step1 = firstPurchase.querySelector('div[data-step="1"]');
    const step2 = firstPurchase.querySelector('div[data-step="2"]');
    const step3 = firstPurchase.querySelector('div[data-step="3"]');
    const step1Choices = step1.querySelectorAll('.choice-btn');
    const step2Choices = step2.querySelectorAll('.choice-btn');
    const secondStepChoiceContainer = step2.querySelector('.first-purchase__first-choice__choice');
    const cartTrail = step3.querySelector('.first-purchase__cart__trail');
    const cartProductName = step3.querySelector('.first-purchase__cart__product-name');
    const cartProductPrice = step3.querySelector('.first-purchase__cart__price-value');
    const goalTables = firstPurchase.querySelectorAll('.goal');

    let firstStepChoice;
    let firstStepChoiceName;
    let secondStepChoice;
    let secondStepChoiceName;
    let secondStepChoicePrice;
    let secondStepChoiceProductId;
    let secondStepChoiceOfferId;

    const changeStep = (stepIndex) => {
        steps.forEach((step, i) => {
            if(stepIndex === i) {
                step.classList.add('active');
            } else {
                step.classList.remove('active');
            }
        });

        window.scrollTo(0, 0);
    }

    const updateStep2 = (choice) => {
        goalTables.forEach(table => {
            if(table.dataset.choice === choice) {
                table.classList.add('active');
            }
            else {
                table.classList.remove('active');
            }
        });
    }

    stepDots.forEach((dot) => {
       dot.addEventListener('click', () => {
           changeStep(parseInt(dot.dataset.step));
       })
    });

    step1Choices.forEach(choice => {
        choice.addEventListener('click', () => {
            firstStepChoice = choice.dataset.choice;
            firstStepChoiceName = choice.dataset.choiceName;

            secondStepChoiceContainer.innerText = firstStepChoiceName;
            updateStep2(firstStepChoice);
            changeStep(1);
        });
    });

    step2Choices.forEach(choice => {
        choice.addEventListener('click', () => {
            secondStepChoice = choice.dataset.choice;
            secondStepChoiceName = choice.dataset.choiceName;
            secondStepChoicePrice = choice.dataset.price;
            secondStepChoiceProductId = choice.dataset.productId;
            secondStepChoiceOfferId = choice.dataset.offerId;

            cartTrail.innerText = firstStepChoiceName;
            cartProductName.innerText = secondStepChoiceName;
            cartProductPrice.innerText = secondStepChoicePrice;

            addBundleToCart(secondStepChoiceProductId, secondStepChoiceOfferId, choice, () => {
                changeStep(2);
            }, firstStepChoice);
        })
    });
}
